import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 4,
      name: i18n.t('tipos.roles.usuario_consulta')
    },
    {
      id: 1,
      name: i18n.t('tipos.roles.usuario')
    },
    {
      id: 2,
      name: i18n.t('tipos.roles.administrador')
    },
    {
      id: 7,
      name: i18n.t('tipos.roles.admin_distribuidor'),
      only: [7, 8, 3]
    },
    {
      id: 8,
      name: i18n.t('tipos.roles.super_admin_distribuidor'),
      only: [8, 3]
    },
    {
      id: 3,
      name: i18n.t('tipos.roles.super_administrador'),
      only: [3]
    },
    {
      id: 9,
      name: i18n.t('tipos.roles.proveedor')
    },
  ]
}

export function ROLES (state) {
  return configHelper.getConfig(state, 'ROLES', GenerateConfig)
}
